import axios from "axios";
import router from "@/router";
import { clearToken, getToken } from "@/auth";

const DEFAULT_TIMEOUT_MS = 5000;

let redirectingToLogin = false;

function redirectToLogin() {
  if (redirectingToLogin) return;
  redirectingToLogin = true;

  const current = router.currentRoute;
  const redirect = current && current.fullPath ? current.fullPath : "/";

  router
    .replace({ path: "/login", query: { redirect } })
    .catch(() => {})
    .finally(() => {
      window.setTimeout(() => {
        redirectingToLogin = false;
      }, 300);
    });
}

export const http = axios.create({
  timeout: DEFAULT_TIMEOUT_MS,
});

export const httpWithToken = axios.create({
  timeout: DEFAULT_TIMEOUT_MS,
});

httpWithToken.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (err) => Promise.reject(err)
);

httpWithToken.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err && err.response && err.response.status;
    const code = err && err.response && err.response.data && err.response.data.code;
    if (status === 401 || status === 403 || code === 401) {
      clearToken();
      redirectToLogin();
    }
    return Promise.reject(err);
  }
);

